import DynamicObject from '../../models/dynamic-object'
import {AxiosResponse} from 'axios'
import Api from '../api'

export default (imageId: string): Promise<AxiosResponse> => {
  const path = 'members/gallery'
  return Api.getInstance().request.delete(`${path}?ids=${imageId}`)
}
